import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { IAttribute, IModel } from '../../base/annotation';
import { Metamodel } from '../../base/model';
import { FtpServerLinkedService } from '../../linkedservice/ftp-server.linkedservice';
import { FilePath } from '../file-path';
import { ILocationPath, Location } from './location';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'FtpServerLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(FtpServerLinkedService)
    }
})
export class FtpServerLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', FtpServerLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', FtpServerLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: FtpServerLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: FtpServerLocation.FILE_NAME.templateValue(this) || this.fileName,
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && FtpServerLocation.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(FtpServerLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(FtpServerLocation.FILE_NAME.templateValue(this));
    }
}
